export default __webpack_public_path__ + "static/media/dropdown-arrow.8e241d8a.svg";